<script setup>
import NextButton from 'dashboard/components-next/button/Button.vue';
import { copyTextToClipboard } from 'shared/helpers/clipboard';
import { useAlert } from 'dashboard/composables';
import { useI18n } from 'vue-i18n';

const props = defineProps({
  text: {
    type: String,
    default: '',
  },
});

const { t } = useI18n();

const onCopy = async e => {
  e.preventDefault();
  await copyTextToClipboard(props.text);
  useAlert(t('COMPONENTS.CODE.COPY_SUCCESSFUL'));
};
</script>

<template>
  <div class="relative text-left flex items-center gap-2">
    <div class="text-n-slate-11 font-mono text-xs tracking-tight flex-1">
      {{ text }}
    </div>
    <NextButton
      slate
      xs
      faded
      :label="t('COMPONENTS.CODE.BUTTON_TEXT')"
      @click="onCopy"
    />
  </div>
</template>
